import styled from 'styled-components'

export const Sidebar = styled.div`
  width: 350px;
  flex-direction: column;
  overflow-y: auto;
`
